export default [
  {
    path: '',
    name: 'cryptomats-orders',
    component: () => import(/* webpackChunkName: "cryptomats-orders" */ '~/views/CryptomatsOrders/CryptomatsOrders.vue'),
    meta: {
      header: { type: 'slot', name: 'HeaderCryptomats' },
    },
  },
  {
    path: 'fees',
    name: 'cryptomats-fees',
    component: () => import(/* webpackChunkName: "cryptomats-fees" */ '~/views/CryptomatsFees/CryptomatsFees.vue'),
    meta: {
      header: { type: 'slot', name: 'HeaderCryptomats' },
    },
  },
  {
    path: 'transactions',
    name: 'cryptomats-transactions',
    component: () => import(/* webpackChunkName: "cryptomats-transactions" */ '~/views/CryptomatsTransactions/CryptomatsTransactions.vue'),
    meta: {
      header: { type: 'slot', name: 'HeaderCryptomats' },
    },
  },
  {
    path: 'atms',
    name: 'cryptomats-atms',
    component: () => import(/* webpackChunkName: "cryptomats-atms" */ '~/views/CryptomatsAtms/CryptomatsAtms.vue'),
    meta: {
      header: { type: 'slot', name: 'HeaderCryptomats' },
    },
  },
  {
    path: 'currencies',
    name: 'cryptomats-currencies',
    component: () => import(/* webpackChunkName: "cryptomats-currencies" */ '~/views/CryptomatsCurrencies/CryptomatsCurrencies.vue'),
    meta: {
      header: { type: 'slot', name: 'HeaderCryptomats' },
    },
  },
  {
    path: 'renters',
    name: 'cryptomats-renters',
    component: () => import(/* webpackChunkName: "cryptomats-renters" */ '~/views/CryptomatsRenters/CryptomatsRenters.vue'),
    meta: {
      header: { type: 'slot', name: 'HeaderCryptomats' },
    },
  },
  {
    path: 'сhecks',
    name: 'cryptomats-сhecks',
    component: () => import(/* webpackChunkName: "cryptomats-сhecks" */ '~/views/CryptomatsСhecks/CryptomatsСhecks.vue'),
    meta: {
      header: { type: 'slot', name: 'HeaderCryptomats' },
    },
  },
];
